import Dialog from '@mui/material/Dialog';
import React, { useMemo } from 'react';

import { RemoveHabitScheduleError } from './remove-habit-schedule-error';
import { RemoveHabitScheduleLoading } from './remove-habit-schedule-loading';
import { RemoveHabitScheduleMessage } from './remove-habit-schedule-message';

export type RemoveHabitScheduleDialogProps = {
  open: boolean;
  name: string;
  onClose: () => void;
  onSubmit: () => void;
  onRetry: () => void;
  isLoading?: boolean;
  isError?: boolean;
};

export const RemoveHabitScheduleDialog: React.FC<
  RemoveHabitScheduleDialogProps
> = ({ open, name, onClose, onRetry, onSubmit, isLoading, isError }) => {
  const content = useMemo(() => {
    if (isError) {
      return (
        <RemoveHabitScheduleError
          name={name}
          onRetry={onRetry}
          onCancel={onClose}
        />
      );
    }

    if (isLoading) {
      return <RemoveHabitScheduleLoading />;
    }

    return (
      <RemoveHabitScheduleMessage
        name={name}
        onSubmit={onSubmit}
        onCancel={onClose}
      />
    );
  }, [isError, isLoading, name, onClose, onRetry, onSubmit]);

  return (
    <Dialog open={open} fullWidth onClose={!isLoading ? onClose : undefined}>
      {content}
    </Dialog>
  );
};
